import React from 'react';
import Grid from '@mui/material/Grid';
import kebabCase from 'lodash/kebabCase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ColumnLinks from '../../../components/ColumnLinks';

import financialHomePageStyles from './financialHomePageStyles';

export const columns1 = [
    {
        title: 'Rates of Exchange',
        link: kebabCase('Rates of Exchange'),
        body: 'Use this module to manage rates of exchange between your system currency and other currencies in use.',
        // eslint-disable-next-line react/display-name
        icon: (props: any) => <FontAwesomeIcon {...props} icon={['fa', 'coins']} />,
        notDeveloped: false,
        permissionId: 'exchange_rate:view'
    },
    {
        title: 'Supplier Reconciliation',
        link: kebabCase('Supplier Reconciliation'),
        body: 'Reconcile supplier accounts and view supplier activity history. In this module, you can view all commitments made to suppliers according to value dates, and to issue payment due to supplier.',
        // eslint-disable-next-line react/display-name
        icon: (props: any) => <FontAwesomeIcon {...props} icon={['fa', 'file-alt']} />,
        notDeveloped: false,
        permissionId: 'supplier_reconciliation:view'
    },
    {
        title: 'BSP Reconciliation',
        link: kebabCase('BSP Reconciliation'),
        body: 'Use this module to import BSP data, match issued tickets with BSP statements, make payments for matched tickets, and view ticketing history.',
        // eslint-disable-next-line react/display-name
        icon: (props: any) => <FontAwesomeIcon {...props} icon={['fa', 'clipboard-list']} />,
        notDeveloped: false,
        permissionId: 'bsp_reconciliation:view'
    },
    {
        title: 'Travel Agent Reconciliation',
        link: kebabCase('Travel Agent Reconciliation'),
        body: 'Use this module to reconcile accounts of travel agents and to view all travel agent payments due to you.',
        // eslint-disable-next-line react/display-name
        icon: (props: any) => <FontAwesomeIcon {...props} icon={['fa', 'suitcase-rolling']} />,
        notDeveloped: false,
        permissionId: 'agent_reconciliation:view'
    },
    {
        title: 'User/Freelancer Reconciliation',
        link: kebabCase('User/Freelancer Reconciliation'),
        body: 'User/Freelancer Reconciliation',
        // eslint-disable-next-line react/display-name
        icon: (props: any) => <FontAwesomeIcon {...props} icon={['fa', 'user']} />,
        notDeveloped: true
    }
];

export const columns2 = [
    {
        title: 'Cashier',
        link: kebabCase('Cashier'),
        body: 'Manage the cash book and view various receipt types (cash, check) that await bank account deposit. Here you can issue bank deposit documents.',
        // eslint-disable-next-line react/display-name
        icon: (props: any) => <FontAwesomeIcon {...props} icon={['fa', 'cash-register']} />,
        notDeveloped: false,
        permissionId: 'cashier:view'
    },
    {
        title: 'Cancelled Receipts',
        link: kebabCase('Cancelled Receipts'),
        body: 'Review cancelled card receipts: the card charge, its live Pelecard status, and the finance decision note.',
        icon: (props: any) => <FontAwesomeIcon {...props} icon={['fa', 'receipt']} />,
        notDeveloped: false,
        permissionId: 'cancelled_receipts:view'
    },
    {
        title: 'Pelecard Transactions',
        link: kebabCase('Pelecard Transactions'),
        body: "Pelecard's own transaction list per terminal — active, transmitted and deleted — matched to the card charges Taytan recorded.",
        icon: (props: any) => <FontAwesomeIcon {...props} icon={['fa', 'credit-card']} />,
        notDeveloped: false,
        permissionId: 'pelecard_transactions:view'
    },
    {
        title: 'Transfer Book',
        link: kebabCase('Transfer Book'),
        body: 'Use this module to update transfer receipts (TRC) with the relevant bank reference',
        // eslint-disable-next-line react/display-name
        icon: (props: any) => <FontAwesomeIcon {...props} icon={['fa', 'piggy-bank']} />,
        notDeveloped: false,
        permissionId: 'transfer_book:view'
    },
    {
        title: 'Export Data',
        // The label is free to change; this string is not — it is the URL
        // (routes.ts derives the same path from the same literal), so renaming
        // the page must not touch it.
        link: kebabCase('Export Data to General Ledger'),
        body: 'Use this module to export accounting transactions to a fixed format file that can be imported into your accounting software.',
        // eslint-disable-next-line react/display-name
        icon: (props: any) => <FontAwesomeIcon {...props} icon={['fa', 'file-export']} />,
        notDeveloped: false,
        permissionId: 'general_ledger:export'
    },
    {
        title: 'Issue Documents',
        link: 'documents/issue',
        body: 'Issue receipts, remittances, tax/agent invoices and credit/debit notes.',
        // eslint-disable-next-line react/display-name
        icon: (props: any) => <FontAwesomeIcon {...props} icon={['fa', 'file-invoice']} />,
        notDeveloped: false,
        permissionId: 'issue_documents:view'
    },
    {
        title: 'Find Documents',
        link: 'documents/find',
        body: 'Search and view existing issued documents.',
        // eslint-disable-next-line react/display-name
        icon: (props: any) => <FontAwesomeIcon {...props} icon={['fa', 'search']} />,
        notDeveloped: false,
        permissionId: 'find_documents:view'
    },
    {
        title: 'Payment Book',
        link: kebabCase('Payment Book'),
        body: 'View & Confirm payment requisitions. Here you can manage all your payments.',
        // eslint-disable-next-line react/display-name
        icon: (props: any) => <FontAwesomeIcon {...props} icon={['fa', 'book']} />,
        notDeveloped: false,
        permissionId: 'payment_book:view'
    },
    {
        title: 'Document Approval',
        link: kebabCase('Document Approval'),
        body: 'Review and approve Payment Requisitions (PRQ) before remittance can be issued. Digitally sign documents with your saved signature.',
        // eslint-disable-next-line react/display-name
        icon: (props: any) => <FontAwesomeIcon {...props} icon={['fa', 'stamp']} />,
        notDeveloped: false,
        permissionId: 'prq_approval:view'
    }
];

const FinancialHomePage = () => {
    const classes = financialHomePageStyles();

    return (
        <Grid container className={classes.container}>
            <ColumnLinks
                basePath="finance"
                items={columns1}
                className={classes.columnStyle}
            />
            <ColumnLinks
                basePath="finance"
                items={columns2}
                className={classes.columnStyle}
            />
        </Grid>
    );
};

export default FinancialHomePage;
